import React from "react";
import { FileCheck2, ReceiptText, ShoppingCart } from "lucide-react";
import PremiumHubPage from "../../../Components/Dashboard/PremiumHubPage";

const GstFiling = ({ navigation }) => {
  const navigateTo = (route) => navigation.navigate(route);

  return (
    <PremiumHubPage
      title="GST Filing"
      subtitle="Review tax summaries and open GST return reports from one clean workspace."
      sections={[
        {
          title: "GST Returns",
          items: [
            {
              label: "GSTR-1 Outward Supplies",
              description: "Invoice-level outward-tax register for GSTR-1 reconciliation.",
              icon: ShoppingCart,
              tone: "blue",
              onClick: () => navigateTo("GstR1"),
            },
            {
              label: "Purchase GST / ITC Register",
              description: "Books register for reconciliation with portal-generated GSTR-2B; not a GSTR-2 return.",
              icon: ReceiptText,
              tone: "green",
              onClick: () => navigateTo("GstR2"),
            },
            {
              label: "GSTR-3B Books Summary",
              description: "Outward tax and purchase-tax summary to reconcile before filing GSTR-3B.",
              icon: FileCheck2,
              tone: "orange",
              onClick: () => navigateTo("GstR3B"),
            },
          ],
        },
      ]}
    />
  );
};

export default GstFiling;
